import { network } from "../network/network.js";
const endpoint = "/orders";
export async function searchOrders(query) {
    return await network(endpoint, { query });
}
export async function createOrder(cart) {
    const response = await network(endpoint, {
        method: "POST",
        json: cart,
    });
    if ("_id" in response) {
        return response;
    }
    return undefined;
}
export async function fetchOrder(id) {
    const response = await network(`${endpoint}/${id}`);
    if ("_id" in response) {
        return response;
    }
    return undefined;
}
export async function createOrderNote(orderId, content) {
    const response = await network(`${endpoint}/${orderId}/notes`, {
        method: "POST",
        json: { content },
    });
    if ("_id" in response) {
        return response;
    }
    return undefined;
}
